import React from 'react';
import { AmountComponent as Amount } from '@alfa-bank/newclick-composite-components/amount';
import cn from 'classnames';
import { useAtomValue } from 'jotai';

import { ProgressBar } from '@alfalab/core-components/progress-bar';
import { Typography } from '@alfalab/core-components/typography';

import { poolProgressAtom } from '../../atoms/money-pool-data/atom';
import { platformAtom } from '../../atoms/platform/atom';
import { defaultAmount } from '../../constants';

import styles from './index.module.css';

export const ProgressInfo = () => {
    const platform = useAtomValue(platformAtom);

    const { progress, name, totalSum, categoryIcon, radianceColor, activePool } =
        useAtomValue(poolProgressAtom);

    return (
        <div className={cn(styles.content, styles[platform])}>
            <div className={styles.info}>
                <Typography.TitleResponsive tag='h5' view='xsmall'>
                    {name}
                </Typography.TitleResponsive>
                <Typography.Title
                    tag='h3'
                    view={platform === 'mobile' ? 'medium' : 'xlarge'}
                    className={styles.amountTitle}
                    dataTestId='progress-amount'
                >
                    <Amount amount={totalSum || defaultAmount} transparentMinor={true} />
                </Typography.Title>
            </div>
            {progress && (
                <div className={cn(styles.progress, styles[platform])}>
                    <ProgressBar
                        view='positive'
                        size={8}
                        value={progress.value}
                        className={styles.progressBar}
                        dataTestId='progress-bar'
                    />
                    {activePool && (
                        <Typography.Text
                            tag='p'
                            view='primary-small'
                            color='secondary'
                            defaultMargins={false}
                            dataTestId='progress-description'
                        >
                            {progress.text}
                        </Typography.Text>
                    )}
                </div>
            )}
            <img
                className={styles.image}
                src={categoryIcon}
                alt='category'
                style={{
                    filter: `drop-shadow(0 0 50px ${radianceColor})`,
                    willChange: 'filter',
                }}
            />
        </div>
    );
};
